import React, { useCallback } from 'react';
import classNames from 'classnames';

import { useUserInfo } from 'lib/user';
import { useUnbindSocialOAuth } from 'api/user_profile/user_profile_social_unbind';
import { useGetSocialOAuth } from 'api/user_profile/user_profile_social_oauth_url';
import { useAppSelector } from 'store/hooks';
import {
  CheckContainedFill,
  Circle,
  TwitterFillBrand,
  XCircleContained,
} from 'lib/lucky-x-icons-2';

const ConnectTwitterLabel = () => {
  const { isLogin } = useUserInfo();
  const { twitterUnbind } = useUnbindSocialOAuth();
  const { twitterOauth } = useGetSocialOAuth();
  const {
    raffleInfo: { my_entry },
    raffleRegisterResult: { validation },
    twitterUsername,
  } = useAppSelector((state) => state.raffleDetails);

  const render = useCallback(() => {
    return (
      <div>
        <div className="flex items-center justify-between text-base font-normal text-neutral-100">
          <div className="flex items-center gap-2">
            <TwitterFillBrand size={24} color="#00A3FF" />
            <div>Twitter</div>
          </div>
          <div>
            {isLogin && twitterUsername ? (
              <div className="flex items-center justify-end gap-2 ">
                <div className="max-w-[140px] truncate font-semibold">
                  @{twitterUsername}
                </div>
                {!my_entry && !validation && (
                  <XCircleContained
                    size={24}
                    className="shrink-0 cursor-pointer"
                    onClick={() => {
                      twitterUnbind();
                    }}
                  />
                )}
              </div>
            ) : (
              <div
                className={classNames(
                  'flex h-8 w-[100px] items-center justify-center gap-1 rounded-full bg-[#00A3FF]',
                  {
                    'cursor-pointer': isLogin,
                    'cursor-not-allowed': !isLogin,
                  }
                )}
                onClick={
                  isLogin
                    ? () => {
                        twitterOauth();
                      }
                    : () => {}
                }
              >
                <TwitterFillBrand size={20} color="#fff" />
                <div className="text-sm font-normal text-white">Connect</div>
              </div>
            )}
          </div>
        </div>

        <div className="mt-2 flex items-center gap-3 rounded-2xl border-[1px] border-neutral-600 p-4">
          {!!twitterUsername ? (
            <CheckContainedFill size={24} color="#98FF59" />
          ) : (
            <Circle size={24} className="text-neutral-400" />
          )}
          <div className="w-full whitespace-pre-line text-base  font-normal text-neutral-100 md:w-auto">
            Connect Twitter
          </div>
        </div>
      </div>
    );
  }, [
    isLogin,
    my_entry,
    twitterOauth,
    twitterUnbind,
    twitterUsername,
    validation,
  ]);

  return <div>{render()}</div>;
};

export default ConnectTwitterLabel;
